import { ValueOf } from '../utilities/types';

const baseRoles = {
  NONE: 'none',
  MANAGER: 'Manager',
  OPERATION_SUPPORT: 'OperationSupport',
  AUDITOR: 'Auditor',
  DEVELOPER: 'Developer',
  ANALYST: 'Analyst',
} as const;

export type BaseRoles = ValueOf<typeof baseRoles>;

export const baseRolesChoices = [
  { id: baseRoles.NONE, name: 'None' },
  { id: baseRoles.MANAGER, name: 'Manager' },
  { id: baseRoles.OPERATION_SUPPORT, name: 'Operations support' },
  { id: baseRoles.AUDITOR, name: 'Auditor' },
  { id: baseRoles.DEVELOPER, name: 'Developer' },
  { id: baseRoles.ANALYST, name: 'Analyst' },
];

export default baseRoles;
